/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

const baseStyles = () => {
    /* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
    return css`
        display: flex;
        gap: 0.8rem;
        margin-bottom: var(--layout-spacing-8);
        min-height: 2.6rem;

        .price {
            margin: 0;
        }

        .price-before-discount {
            ${theme.typography.body_normal_highlight};
            color: var(--colors-text-primary);
            text-decoration: line-through;
        }
    `;
    /* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
};

export const styles = () => css`
    ${baseStyles()}
`;
